export enum SelectionOrderType {
  SERVICE_LOCATION_EMPLOYEE = 'service_location_employee',
  SERVICE_EMPLOYEE_LOCATION = 'service_employee_location',
  LOCATION_SERVICE_EMPLOYEE = 'location_service_employee',
  LOCATION_EMPLOYEE_SERVICE = 'location_employee_service',
  EMPLOYEE_SERVICE_LOCATION = 'employee_service_location',
  EMPLOYEE_LOCATION_SERVICE = 'employee_location_service'
}
